import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  CsvFile,
  FullTable,
  TableWrapper,
  CustomButtonsTab,
  DateSelector,
  UserInputsDropdown,
  SearchInput,
} from 'components';
import { httpRequestsOnSuccessActions, loadActions, mcActions, officeActions } from 'store';
import {
  FindSuccessItem, isAdmin, isFactored,
  PermissionsList,
  RolePermission, SavePage, SaveParams,
  useModal,
  usePrimaryModal,
  userType, useTertiaryModal,
} from 'utils';
import { loadsBody, loadsHead, loadCsv, loadTabs, LOAD_ACTION_TYPE } from './constants';
import { CreditCheck } from '../core';
import { CreateLoadBtn } from '../../../fragments/loads/createLoad/core';
import { LoadDetailSwitcher } from '../loadDetailSwitcher';
import { groupList, loadList, loadSearchEnums, RENDER_LOADS } from '../constants';
import { GET_LOADS_BY_STATUS } from '../../../store/loads/loads.types';
import { LoadStatus } from '../../../components/inputs/autocompleteSelectInput';
import { filtersFragment } from '../../../components/filters/styles';
import { LOAD_REVISION, LOAD_VERIFICATION } from '../../accounting/constants';
import { GroupedLoadDetails } from '../../../fragments';

export const LoadCard = ({}) => {
  const { loadsList, mcsList, officesList } = useSelector((state) => ({
    loadsList: state.loads.loadsList,
    mcsList: state.mcs.mcsList,
    officesList: state.offices.officesList,
  }));
  const filterClasses = filtersFragment();
  const { open } = useModal();
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;
  const { openPrimary } = usePrimaryModal();
  const renderLoads = FindSuccessItem(RENDER_LOADS);
  const { openTertiary } = useTertiaryModal();

  // useEffect(() => {
  //   if (!info?.from && !info?.to) {
  //     const params = {
  //       ...info
  //     }
  //     params.from = moment.utc().subtract(1, 'month').startOf('day').format('YYYY-MM-DDT00:00:01');
  //     params.to = moment.utc().endOf('day').format('YYYY-MM-DDT23:59:59');
  //     SaveParams(history, params);
  //   }
  // }, []);

  const renderParams = () => {
    const filteredInfo = {
      ...info,
    };
    filteredInfo.skip = info?.skip ? info?.skip : 0;
    filteredInfo.limit = 100;
    info?.status === 'ALLLOADS' && delete filteredInfo.status;

    // if (!info?.from && !info?.to) {
    //   filteredInfo.from = moment().subtract(1, 'month').startOf('day').format('YYYY-MM-DDT00:00:01');
    //   filteredInfo.to = moment().endOf('day').format('YYYY-MM-DDT23:59:59');
    // }

    // if (info?.from) {
    //   filteredInfo.from = moment(info?.from).format('YYYY-MM-DDT00:00:01');
    // }
    // if (!info?.to) {
    //   filteredInfo.to = moment().format('YYYY-MM-DDT23:59:59');
    // } else {
    //   filteredInfo.to = moment(filteredInfo.to).format('YYYY-MM-DDT23:59:59');
    // }
    delete filteredInfo.page;
    delete filteredInfo.activeTab;
    delete filteredInfo.tabType;
    // delete filteredInfo.loadParams;

    if (userType === 'AGENT' && !info?.statuses) {
      filteredInfo.statuses = ['PENDING', 'INTRANSIT', 'CREDITCHECK'];
      filteredInfo.isRevision = true;
      filteredInfo.isVerification = true;
    }
    if (info?.statuses && info?.statuses?.length === 0) {
      delete filteredInfo.isRevision;
      delete filteredInfo.isVerification;
      delete filteredInfo.statuses;
    }
    info?.containerNumber ? filteredInfo.containerNumber = info?.containerNumber : delete filteredInfo.containerNumber;
    return filteredInfo;
  };

  useEffect(() => {
    handleGet('loading');
    const interval = setInterval(() => {
      handleGet('noLoad');
    }, 30000);
    return () => clearInterval(interval);
  }, [info]);

  useEffect(() => {
    if (renderLoads) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(RENDER_LOADS));
      handleGet('noLoad');
    }
  }, [renderLoads]);

  useEffect(() => {
    if (isAdmin) {
      dispatch(mcActions.getMcs());
      dispatch(officeActions.getOffices());
    }
  }, []);

  const handleGet = (loading) => {
    const loader = loading === 'loading' ? 'loading' : 'noLoad';
    const filteredInfo = renderParams();
    dispatch(loadActions.getLoadsByStatus({ ...filteredInfo }, loader));
  };

  const pushPageDetails = (item) => {
    // if(item?.loadGroup){
    //   openTertiary(<GroupedLoadDetails id={item?.loadGroup}/>)
    // }else{
      openPrimary(<LoadDetailSwitcher loadId={item?.id} />);
    // }
  };

  const rowClick = (item) => {
    if(item?.loadGroup){
      openTertiary(<GroupedLoadDetails id={item?.loadGroup}/>)
    }else{
      openPrimary(<LoadDetailSwitcher loadId={item?.id} />);
    }
  }

  const handleChange = (value, name) => {
    const params = {
      ...info,
    };
    params.limit = 100;
    params.skip = 0;
    params.page = 1;
    if (value) {
      params[name] = value.id;
    } else {
      delete params[name];
    }
    SavePage(history, info, { ...params });
  };

  const handleSelect = (items, v) => {
    // handleSelectStatus && handleSelectStatus()
    const revision = items?.length && items?.find((i) => i.id === LOAD_REVISION);
    const verification = items?.length && items?.find((i) => i.id === LOAD_VERIFICATION);
    let statusList = [];

    const newObj = {
      ...info,
    };
    newObj.limit = 100;
    newObj.skip = 0;
    newObj.page = 1;

    items?.length && items.forEach(function(status) {
      // if (status.id !== LOAD_REVISION && status.id !== LOAD_VERIFICATION) {
      statusList.push(status.id);
      // }
    });


    if (revision) {
      newObj.isRevision = true;
    } else {
      delete newObj.isRevision;
    }

    if (verification) {
      newObj.isVerification = true;
    } else {
      delete newObj.isVerification;
    }

    newObj.statuses = statusList;
    SavePage(history, info, { ...newObj });
  };

  return (
    <div>
      <div className='space-between' style={{ marginBottom: '16px', alignItems: 'flex-start' }}>
        <CustomButtonsTab
          first={'loads'}
          second={'Load Groups'}
          width={'150px'}
          maxWidth={'320px'}
          firstName={loadTabs?.LOADS}
          secondName={loadTabs?.LOAD_GROUPS}
        />
        <div className='align-center'>
          {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.EXPORT_LOAD_CSV?.code], 'officeManager') &&
            <CsvFile params={loadCsv} />
          }
          {userType !== 'ADMIN' &&
            <div className='align-center' style={{ marginBottom: '16px' }}>
              <button className='credit-check-btn' onClick={() => open(<CreditCheck />)}>
                Credit Check
              </button>
              <CreateLoadBtn />
            </div>
          }
        </div>
      </div>

      <div className='align-center full-width' style={{ gap: 16 }}>
        <DateSelector
          startName={'from'}
          endName={'to'}
        />
            <LoadStatus
              handleChange={handleSelect}
              permissionsList={info?.tabType === loadTabs?.LOAD_GROUPS ? groupList : loadList}
              label={'Select Status'}
              info={info}
            />
            {isAdmin &&
              <UserInputsDropdown
                styles={{ marginRight: 0 }}
                dropdownOptions={mcsList?.mcs}
                onPass={(option) => handleChange(option, 'mc')}
                selected={info?.mc ? info?.mc : ''}
                noText={'All Authority'}
                firstText={'name'}
              />
            }
            {!isFactored &&
              <UserInputsDropdown
                styles={{ marginRight: 0 }}
                dropdownOptions={officesList?.offices}
                onPass={(option) => handleChange(option, 'office')}
                selected={info?.office ? info?.office : ''}
                noText={'All Offices'}
                firstText={'name'}
              />
            }

          <SearchInput

            // className={filterClasses.searchByContainer}
            name="containerNumber"
            placeholder="Search by Container No.(CN)"
          />
      </div>

      <TableWrapper
        firstButton={'Active'}
        secondButton={'Inactive'}
        addButton={'Add Load'}
        buttonsTab={userType !== 'ADMIN'}
        tab={'none'}
        buttonsTabAddButton={false}
      >
        <FullTable
          head={loadsHead(info?.tabType)}
          body={loadsBody(info?.tabType, rowClick)}
          loadingType={LOAD_ACTION_TYPE}
          list={loadsList?.loads}
          listCount={loadsList?.count}
          handleClick={pushPageDetails}
          noText={'Loads'}
          // dateFilter={true}
          // typeForFilter={true}
          // dateFrom={true}
          padding={'12px 10px'}
          paddingHead={'16px 10px'}
          clickType={'item'}
          // office={true}
          // searchByContainerNumber
        />
      </TableWrapper>
    </div>
  );
};
